module.exports = __webpack_public_path__ + "img/head-logo.030b730d.png";